<!--投資組合--><template>
	<div class="page-body center-wrap">
		<titleModel></titleModel>

		<div class="top-div">
			<div class="left-con">
				<img :src="defaultCoin.image" alt="">
				<span class="right">
					<span>{{ defaultCoin.symbol }}</span>
					<span>
						<span class="txt1">{{ defaultCoin.total_profit || '0.00' }}</span>
						<span class="sws">{{ $t('总收益') }}</span>
					</span>
				</span>
			</div>
			<div class="portfolio-quotes">
				<div class="bitem" v-for="value in productList" :key="value.id">
					<div class="name">{{ value.symbol }}</div>
					<div class="price">
						<img alt="" :src="value.image" class="lazy-img">
						{{ Number(value.price) }}
					</div>
				</div>
			</div>
		</div>

		<ul class="list">
			<li class="item" v-for="item in list" :key="item.id">
				<img alt="" v-if="item.hot == 1" src="@/assets/img-pc/56.cefb45b9.svg" class="lazy-img icon-hot">
				<p class="p1">{{ item.invest }}</p>
				<p class="p2">
					<span>{{ $t('投资金额') }}:{{ item.amount }}-{{ item.amax }}</span>
					<span class="svg-container svg-img white">
						<!-- svg 保留 -->
						<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
							class="svg-class">
							<g id="Frame">
								<path id="Vector"
									d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
								</path>
							</g>
						</svg>
					</span>
				</p>
				<img :src="item.bg_image" class="asas-img">
				<div class="middle">
					<span class="beneif">
						<span>{{ $t('收益率') }}</span>
						<span>{{ $t('时长') }}: {{ item.days }}{{ $t('日') }}</span>
					</span>
					<span class="text">{{ item.ratemax }}%
						<span class="dacdy">/{{ $t('天') }}</span>
						<span class="leftTimes">{{ $t('剩余次数') }}:{{ item.remaining_number }}</span>
					</span>
				</div>
				<button class="cur-poi" @click="$nav.go(`/pc/portfolioDetails?id=${item.id}&invest=${item.invest}`)">
					<i class="icon-plus"></i> {{ $t('参与使用') }}
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import titleModel from './components/title.vue';
export default {
	components: {
		titleModel,
	},
	data() {
		return {
			combineData: {}
		};
	},
	created() {
		get(apis.getQuantCombineData).then(res => {
			if (res.code != 1) return
			this.combineData = res.data
		})
	},
	computed: {
		defaultCoin() {
			return this.combineData.default_coin || {}
		},
		productList() {
			return this.combineData.product_list || []
		},
		list() {
			return this.combineData.list || []
		},
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.list {
	display: flex;
	flex-wrap: wrap;

	.item {
		flex: none;
		width: calc(33.33333% - 30px);
		border-radius: 8px;
		overflow: hidden;
		color: #fff;
		background: #2c2c3e;
		box-shadow: 0 0 10px rgba(0, 0, 0, .10196078431372549);
		font-size: 12px;
		font-weight: 700;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		padding: 20px 16px;
		margin-right: 30px;
		margin-bottom: 30px;

		button {
			position: relative;
			z-index: 2;
			color: #000;
			background: #00f0ff;
			width: 100%;
			height: 60px;
			margin: 10px auto;
			font-size: 18px;
			border-radius: 100px;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			border-width: 0;
		}

		.middle {
			position: relative;
			z-index: 2;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.text {
				font-size: 32px;

				.dacdy {
					font-size: 20px;
				}

				.leftTimes {
					margin-left: 8px;
					font-size: 14px;
				}
			}

			.beneif {
				span {
					&:first-of-type {
						font-size: 16px;
						margin-right: 10px;
					}

					&:nth-of-type(2) {
						background: #ff3131;
						color: #fff;
						padding: 8px 14px;
						border-radius: 16px;
						font-size: 14px;
					}
				}
			}
		}

		.asas-img {
			width: 100%;
			height: auto;
		}

		.p2 {
			position: relative;
			z-index: 2;
			padding: 0;
			font-size: 16px;
			height: 22px;
			color: #fff;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: normal;

			.svg-img {
				margin-top: 4px;
				margin-left: 4px;
			}

			span {
				opacity: .6;
			}
		}

		.p1 {
			position: relative;
			z-index: 2;
			height: 32px;
			padding: 0;
			font-weight: 700;
			font-size: 24px;
			margin-bottom: 0;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.icon-hot {
			position: absolute;
			z-index: 3;
			top: 0;
			right: 0;
		}
	}
}

.top-div {
	display: flex;
	flex-wrap: nowrap;
	flex-direction: row;
	align-items: center;
	justify-content: normal;
	padding: 20px 0;
	justify-content: space-between;

	.portfolio-quotes {
		// width: 500px;
		flex: 1;
		margin-left: 10%;
		overflow-x: auto;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-bottom: 20px;

		.bitem {
			margin-left: 60px;
			text-align: center;

			.price {
				display: flex;
				align-items: center;
				font-size: 16px;
				font-weight: 700;

				img {
					width: 14px;
					height: 14px;
					margin-right: 3px;
				}
			}

			.name {
				font-size: 12px;
				color: #888;
				margin-bottom: 5px;
			}

			&:first-child {
				margin-left: 10px;
			}
		}
	}

	.left-con {
		display: flex;
		align-items: center;

		.right {
			display: flex;
			flex-wrap: nowrap;
			flex-direction: column;
			align-items: normal;
			justify-content: center;
			padding-left: 12px;

			span {
				display: flex;
				align-items: center;

				.txt1 {
					height: 32px;
					font-weight: 700;
					font-size: 24px;
				}

				.sws {
					display: inline-block;
					height: 26px;
					line-height: 26px;
					text-align: center;
					padding: 0 8px;
					background: #ff1843;
					color: #fff;
					border-radius: 8px;
					margin-left: 10px;
					font-size: 12px;
				}
			}
		}

		img {
			width: 80px;
			height: 74px;
		}
	}
}
</style>